/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAcUnit from '../../../../../../Icon/IconAcUnit';
import IconAirportShuttle from '../../../../../../Icon/IconAirportShuttle';
import IconAllInclusive from '../../../../../../Icon/IconAllInclusive';
import IconBeachAccess from '../../../../../../Icon/IconBeachAccess';
import IconBusinessCenter from '../../../../../../Icon/IconBusinessCenter';
import IconCasino from '../../../../../../Icon/IconCasino';
import IconChildCare from '../../../../../../Icon/IconChildCare';
import IconChildFriendly from '../../../../../../Icon/IconChildFriendly';
import IconFitnessCenter from '../../../../../../Icon/IconFitnessCenter';
import IconFreeBreakfast from '../../../../../../Icon/IconFreeBreakfast';
import IconGolfCourse from '../../../../../../Icon/IconGolfCourse';
import IconHotTub from '../../../../../../Icon/IconHotTub';
import IconKitchen from '../../../../../../Icon/IconKitchen';
import IconPool from '../../../../../../Icon/IconPool';
import IconRoomService from '../../../../../../Icon/IconRoomService';
import IconSmokeFree from '../../../../../../Icon/IconSmokeFree';
import IconSmokingRooms from '../../../../../../Icon/IconSmokingRooms';
import IconSpa from '../../../../../../Icon/IconSpa';

export default function PlacesIcons() {
  return (
    <div>
      <CategoryHeader>places</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAcUnit size="32"/>
          <FigCaption>
            IconAcUnit
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAirportShuttle size="32"/>
          <FigCaption>
            IconAirportShuttle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAllInclusive size="32"/>
          <FigCaption>
            IconAllInclusive
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBeachAccess size="32"/>
          <FigCaption>
            IconBeachAccess
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBusinessCenter size="32"/>
          <FigCaption>
            IconBusinessCenter
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconCasino size="32"/>
          <FigCaption>
            IconCasino
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconChildCare size="32"/>
          <FigCaption>
            IconChildCare
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconChildFriendly size="32"/>
          <FigCaption>
            IconChildFriendly
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFitnessCenter size="32"/>
          <FigCaption>
            IconFitnessCenter
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFreeBreakfast size="32"/>
          <FigCaption>
            IconFreeBreakfast
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconGolfCourse size="32"/>
          <FigCaption>
            IconGolfCourse
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHotTub size="32"/>
          <FigCaption>
            IconHotTub
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconKitchen size="32"/>
          <FigCaption>
            IconKitchen
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPool size="32"/>
          <FigCaption>
            IconPool
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconRoomService size="32"/>
          <FigCaption>
            IconRoomService
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSmokeFree size="32"/>
          <FigCaption>
            IconSmokeFree
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSmokingRooms size="32"/>
          <FigCaption>
            IconSmokingRooms
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSpa size="32"/>
          <FigCaption>
            IconSpa
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/PlacesIcons.js